export const PANEL1 = 'panel1';
export const PANEL2 = 'panel2';
export const POLICY_PRIVACY = 'http://rabieski.pl/?page_id=4909';
export const EMAIL_REGEX = /^\S+@\S+\.\S+$/;
